import React from 'react';
import CommandButtonComponent from "./CommandButtonComponent";
import CommandIdEnum from "../../enums/CommandIdEnums";
import { useViewerStateStore } from "../../store/viewerStateStore";
import { useServicesState } from "../../store/servicesStateStore";
import { useUserRightsStore } from "../../store/userRightsStore";
import { GbApiUserRightEnum } from "../../enums/GbApiUserRightEnum";
import "./CommandToolBarComponent.css";

const CommandToolBarComponent: React.FC = () => {
    const { isDebugMode } = useViewerStateStore();
    const canInspectElements = useServicesState(s => s.dataProvider?.canInspectElements() ?? false);
    const canViewBundles = useUserRightsStore(s => s.rights[GbApiUserRightEnum.BundlesView] === true);

    return (
        <div className="toolbar">
            {canInspectElements && canViewBundles && (
                <CommandButtonComponent
                    commandId={CommandIdEnum.BundleInspector}
                    commandNameResourceKey={"command.bundleInspector.title"}
                />
            )}

            <CommandButtonComponent
                commandId={CommandIdEnum.AddLengthDimension}
                commandNameResourceKey={"command.addLengthDimension.title"}
            />

            <CommandButtonComponent
                commandId={CommandIdEnum.AddTextAnnotation}
                commandNameResourceKey={"command.addTextAnnotation.title"}
            />

            <CommandButtonComponent
                commandId={CommandIdEnum.AddAreaAnnotation}
                commandNameResourceKey={"command.addAreaAnnotation.title"}
            />

            <CommandButtonComponent
                commandId={CommandIdEnum.AddRectangleAnnotation}
                commandNameResourceKey={"command.addRectangleAnnotation.title"}
            />

            <CommandButtonComponent
                commandId={CommandIdEnum.AddCircleAnnotation}
                commandNameResourceKey={"command.addCircleAnnotation.title"}
            />

            {isDebugMode && (
                <CommandButtonComponent
                    commandId={CommandIdEnum.AddChecklistItem}
                    commandNameResourceKey={"command.addChecklistItem.title"}
                />
            )}
            
            {isDebugMode && (
                <CommandButtonComponent
                    commandId={CommandIdEnum.RemoveFromDocument}
                    commandNameResourceKey={"command.removeFromDocument.title"}
                />
            )}

        </div>
    );
};

export default CommandToolBarComponent;
